import React, {
  useState,
} from "react";

import {
  makeStyles,
  TextField,
  IconButton,
  InputAdornment
} from "@material-ui/core";
import SearchIcon from '@material-ui/icons/Search';

import {
  useCurl
} from "zh-common-modules";
import HelperContent from "./HelperContent";
import PDFDialog from "../AuthenticationList/Dialog";
import {
  AUTHORIZE_INFO_GET
} from "config/url";

const useStyles = makeStyles(theme => ({
  container : {
    width : "100%",
    height : "100%",
    position : "relative",
    overflow : "hidden"
  },
  content : {
    position : "absolute",
    left : "50%",
    transform : "translate(-50%)",
    textAlign : "center",
    padding : theme.spacing(2, 0, 0, 0)
  },
  helperContent : {
    padding : theme.spacing(2, 0, 0, 0)
  }
}))

export default function SearchView(props){
  const classes = useStyles();
  const {
    curl
  } = useCurl(false, false);
  const [searchValue, setValue] = useState("");
  const [content, setContent] = useState("");
  const [open, setOpen] = useState(false);

  const onChange = (e) => {
    const {
      value
    } = e.target;
    setValue(value);
  }

  const handleSearch = () => {
    curl.get(AUTHORIZE_INFO_GET, {
      code : searchValue
    }).then(res => {
      const {
        showhtml = ""
      } = res;
      if(!showhtml) setOpen(true);
      setContent(showhtml);
    })
  }

  return (
    <div
      className={classes.container}
    >
      <div
        className={classes.content}
      >
        <TextField
          variant = "outlined"
          label = {"授权函编号"}
          value = {searchValue}
          onChange = {onChange}
          InputProps={{
            endAdornment:
              <InputAdornment position="end">
                <IconButton onClick={handleSearch}>
                  <SearchIcon/>
                </IconButton>
              </InputAdornment>
          }}
        />
        {!content && <PDFDialog
          open = {open}
          setOpen = {setOpen}
          fileId = {searchValue}
        />}
        <div className={classes.helperContent}>
          <HelperContent
            content = {content}
          />
        </div>
      </div>
    </div>
  )
}